export default __webpack_public_path__ + "static/media/car-dashboard.c2cf9ad4.png";